import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  padding: 12px 36px;\n\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  \n  &:hover {\n    text-decoration: none;\n    box-shadow: 0 10px 10px -5px rgba(0, 0, 0, 0.3),\n      0 10px 10px -5px rgba(143, 23, 209, 0.4);\n  }\n  \n  :disabled:hover {\n    box-shadow: none;\n  }\n  \n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import ThemedButton from "../common/ThemedButton";
var ShopperThemedButton = styled(ThemedButton)(_templateObject(), function(param) {
    var _embedded = param.embedded, embedded = _embedded === void 0 ? false : _embedded;
    return !embedded && "\n      text-transform: none;\n\n      border-radius: 29px;\n      border: 2px solid ".concat(function(param) {
        var theme = param.theme;
        return theme.button.enabled.backgroundColor;
    }, ";\n\n      font-size: 14px;\n\n      line-height: 14px;\n      letter-spacing: 0.8px;\n  ");
});
export default ShopperThemedButton;
